  <template>
  <div id="sub-events">
    <div class="content-wrapper">
      <portal to="action-buttons"></portal>
      <div class="content animated fadeIn">
        <div class="card" style="padding:0px; box-shadow:unset;">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <h5 class="card-title">{{this.$t("event.components.liveEventExp.nav.scenes.designs")}}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button
                    icon="fas fa-redo-alt"
                    size="mini"
                    @click="$store.dispatch('getScenes')"
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.addNew')" placement="top">
                  <el-button
                    icon="fas fa-plus"
                    size="mini"
                    type="primary"
                    @click="updateForm = null;
                modalVisible = true;"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="col-md-12">
            <div class="scenes">
              <div
                v-for="(item, index) in $store.state.scenes.items"
                :key="item.id"
                class="scene-wrapper"
              >
                <div class="scene" :style="'background-image: url(' + item.background + ');'">
                  <div class="banner" :style="'background-image: url(' + item.top + ');'"></div>
                  <span
                    style="font-size: 18px; font-weight: bold; color: white; text-shadow: 0px 0px 8px rgba(0,0,0,1); display: block; background-color: rgba(0,0,0,.5); width: 100%; text-align: center"
                  >{{item.title}}</span>
                  <div class="banner" :style="'background-image: url(' + item.bottom + ');'"></div>
                </div>
                <el-button-group
                  style="width: 100%; background-color: #fff; display: flex; align-items: center; justify-content: center; padding-top: 10px"
                >
                  <el-button
                    size="mini"
                    type="primary"
                    @click="updateForm = JSON.parse(JSON.stringify(item)); modalVisible = true"
                  >{{$t('event.table.edit')}}</el-button>
                  <el-popconfirm
                    :confirmButtonText="$t('event.variables.yes')"
                    :cancelButtonText="$t('event.buttons.cancel')"
                    icon="el-icon-info"
                    iconColor="red"
                    :title="$t('sureToDelS')"
                    @confirm="deleteItem(index)"
                  >
                    <el-button slot="reference" size="mini" type="danger">{{ $t('event.table.delete') }}</el-button>
                  </el-popconfirm>

                  <el-button
                    size="mini"
                    type="primary"
                    @click="$store.dispatch('copyScene', item.id)"
                  >{{$t('event.buttons.copy')}}</el-button>
                </el-button-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="modalVisible"
      :title="$t('event.components.liveEventExp.nav.scenes.addScene')"
      width="60%"
      :append-to-body="true"
    >
      <SceneAddUpdate
        @deleteMe="deleteItem"
        @closeMe="modalVisible = false"
        @itemUpdated="itemUpdated"
        @itemAdded="itemAdded"
        :data="updateForm"
      />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import PageCountInfo from "./PageCountInfo";
import SceneAddUpdate from "./SceneAddUpdate";
import $ from "jquery";
export default {
  components: { PageCountInfo, SceneAddUpdate },
  name: "Scenes",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "questionlibrary",
    };
  },
  methods: {
    handleSizeChange(take) {
      this.$store.commit("setSubEventsTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setSubEventsPage", page);
    },
    itemUpdated(item) {
      var index = this.$store.state.scenes.items.findIndex(
        (k) => k.id == item.id
      );
      if (index != -1) {
        this.$store.state.scenes.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
    },
    deleteItem(index) {
      this.$store.dispatch("deleteScene", { index, context: this });
    },
  },
  mounted() {
  },
};
</script>


<style>
.scenes {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.scenes .scene {
  background-size: cover;
  display: flex;

  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  overflow: hidden;
  height: 150px;
}

.scene-wrapper {
  width: calc(24% - 10px);
  background-color: grey;
  margin: 10px;
}

.scene .background {
  display: flex;
  flex: 1;
  background: green;
  height: 100%;
  width: 100%;
}

.scene .banner {
  height: 40px;
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Scenes.vue